{
  "envelope": { "center": [0, 0, 5000], "semiAxes": [10000, 2500, 7000] },
  "pocketRadius": 1000,
  "clumpShare": 0.7,
  "verticalSigmaScale": 0.3,
  "clumps": [
    { "center": [-1800, 200, -600], "sigma": 900, "bias": { "archetype": "E", "factor": 3 } },
    { "center": [3200, -300, 1800], "sigma": 1400 },
    { "center": [-4800, 400, 4200], "sigma": 2000 },
    { "center": [1200, 0, 6500], "sigma": 2400 },
    { "center": [6200, 300, 7200], "sigma": 1800 },
    { "center": [-2600, -500, 9800], "sigma": 2200 }
  ],
  "lanes": [
    { "name": "spine run", "from": [0, 0, 0], "to": [600, 0, 11000], "clearRadius": 450 },
    { "name": "derelict crossing", "from": [-8500, 0, 1500], "to": [8500, 0, -300], "clearRadius": 400 }
  ],
  "sizeBins": [
    { "radius": [3, 15], "count": { "high": 1500, "medium": 700, "low": 0 }, "mix": [46, 30, 9, 5, 7, 3] },
    { "radius": [15, 40], "count": { "high": 400, "medium": 400, "low": 400 }, "mix": [42, 12, 20, 12, 10, 4] },
    { "radius": [40, 120], "count": { "high": 90, "medium": 90, "low": 90 }, "mix": [35, 5, 30, 18, 8, 4] },
    { "radius": [150, 300], "count": { "high": 10, "medium": 10, "low": 10 }, "mix": [20, 0, 40, 30, 0, 10] }
  ],
  "spin": [
    { "maxRadius": 15, "degPerSec": [0.5, 4] },
    { "maxRadius": 40, "degPerSec": [0.1, 0.5] }
  ],
  "colliderScale": 0.8,
  "derelict": { "position": [-1600, 300, -1200], "rollDeg": 12, "faceToward": [0, 0, 0], "clearRadius": 250 }
}
